import React, { useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";

import TransferProjectModal from "./TransferProjectModal";

const ProjectActionsMenu = ({ project, clientLabel = "Client", projectLabel = "Project", onSuccess }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [transferModalOpen, setTransferModalOpen] = useState(false);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleTransferClick = () => {
    handleClose();
    setTransferModalOpen(true);
  };

  return (
    <>
      <IconButton
        aria-label="more options"
        aria-controls={open ? "project-actions-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="project-actions-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "project-actions-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            minWidth: 200,
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
            border: "1px solid",
            borderColor: "divider",
          },
        }}
      >
        <MenuItem onClick={handleTransferClick}>
          <ListItemIcon>
            <SwapHorizIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Transfer to Another {clientLabel}</ListItemText>
        </MenuItem>
      </Menu>

      {transferModalOpen && (
        <TransferProjectModal
          project={project}
          clientLabel={clientLabel}
          projectLabel={projectLabel}
          open={transferModalOpen}
          onClose={() => setTransferModalOpen(false)}
          onSuccess={onSuccess}
        />
      )}
    </>
  );
};

export default ProjectActionsMenu;
